import type { FC } from "react";
import type {
  QuestionsDispatch,
  QuestionWithTemporaryId,
} from "../../../projects/recruitingQuestions/questionsStore.js";
import { QuestionsSuggestionsWidget } from "../../../projects/recruitingQuestions/questionsSuggestionsWidget.js";
import { BaseInterviewSectionDefinitionCard } from "../card.js";
import { QuestionsInterviewSectionDefinitionSettings } from "./settings.js";

export interface QuestionsInterviewSectionDefinitionCardProps {
  interviewSectionDefinitionId: string;
  projectId: string;
  questions: readonly QuestionWithTemporaryId[] | undefined;
  onQuestionsChange: QuestionsDispatch | undefined;
}

/**
 * Card in right-side panel for the interview section that contains interview questions.
 */
export const QuestionsInterviewSectionDefinitionCard: FC<
  QuestionsInterviewSectionDefinitionCardProps
> = (props) => (
  <BaseInterviewSectionDefinitionCard
    interviewSectionDefinitionId={props.interviewSectionDefinitionId}
    title="Screening interview"
    titleAccessory={<QuestionsSuggestionsWidget projectId={props.projectId} />}
    subtitle="The AI interviewer will automatically ask clarifying questions and adapt
        to the candidate's responses."
  >
    {props.questions && props.onQuestionsChange ? (
      <QuestionsInterviewSectionDefinitionSettings
        questions={props.questions}
        onQuestionsChange={props.onQuestionsChange}
      />
    ) : (
      // TODO: Support questions sections that are independent from the project / job type.
      <div className="p-3 text-sm text-foreground">
        This section type is not supported.
      </div>
    )}
  </BaseInterviewSectionDefinitionCard>
);
